'use client';

import React from 'react';
import { ListingSellerExternalLink } from '@/client/components/Listings/atoms';
import { Trans } from '@ecg-marktplaats/js-react-i18n';

import Classes from './SellerExternalWebsite.module.scss';

interface SellerExternalWebsiteProps {
  sellerWebsiteUrl: string;
}

/**
 * This is link to visit the website
 * of the seller providing they have provided one.
 * Importantly this only applies to the mobile view.
 */
const SellerExternalWebsite: React.FC<SellerExternalWebsiteProps> = ({ sellerWebsiteUrl }) => (
  <span suppressHydrationWarning className={Classes.sellerExternalLink}>
    <ListingSellerExternalLink url={sellerWebsiteUrl} className="hz-TextLink">
      <Trans tagName="span" i18nKey="listings.visit" />
    </ListingSellerExternalLink>
  </span>
);

export default SellerExternalWebsite;
